import React, { useState } from "react";

export default function PaymentModal({ open, onClose, onPay }) {
  const [selectedPackage, setSelectedPackage] = useState("basic");
  const [paymentType, setPaymentType] = useState("oneTime");

  if (!open) return null;

  const packages = {
    basic: {
      name: "Card + Band Aid",
      icon: "🩹",
      oneTime: 5,
      yearly: 50,
      details: "All information on the card plus the band aid",
    },
    premium: {
      name: "Complete Medical Records",
      icon: "📄",
      oneTime: 10,
      yearly: 100,
      details:
        "Complete medical records (history) of the patient, past and present, Email to their doctors upon request.",
    },
  };

  const selected = packages[selectedPackage];
  const price = paymentType === "oneTime" ? selected.oneTime : selected.yearly;
  const payLabel =
    paymentType === "oneTime"
      ? `Pay $${price.toFixed(2)} Now`
      : `Pay $${price.toFixed(2)} per year`;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 p-4">
      <div className="bg-white rounded-3xl shadow-2xl p-0 w-full sm:max-w-2xl border border-[#e5e7eb] relative overflow-y-auto max-h-[calc(100vh-2rem)] hide-scrollbar">
        <button
          className="absolute top-5 right-6 text-gray-400 hover:text-gray-600 text-2xl font-bold z-10"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>
        <div className="flex flex-col items-center px-8 pt-10 pb-8">
          <div className="bg-[#f7f8fa] rounded-full p-4 mb-4 flex items-center justify-center">
            <svg width="44" height="44" fill="none" viewBox="0 0 24 24">
              <rect width="24" height="16" y="4" rx="3" fill="#2d348f" />
              <rect width="20" height="12" x="2" y="6" rx="2" fill="#fff" />
              <rect width="16" height="2" x="4" y="10" rx="1" fill="#e6e9f5" />
            </svg>
          </div>
          <h2 className="text-3xl font-extrabold text-[#2d348f] mb-2 text-center">
            Choose Your Subscription
          </h2>
          <p className="text-[#837f90] mb-8 text-center text-base">
            Select the plan that best fits your needs.
          </p>
          <div className="w-full flex flex-col md:flex-row gap-6 mb-8">
            {/* Package 1 */}
            <label
              className={`flex-1 border-2 rounded-2xl p-6 flex flex-col cursor-pointer transition-all shadow-sm ${
                selectedPackage === "basic"
                  ? "border-[#2d348f] bg-[#f7f8fa] ring-2 ring-[#2d348f]/20"
                  : "border-gray-200 bg-white"
              } hover:shadow-lg group relative`}
            >
              <div className="flex items-center mb-3">
                <span className="text-4xl mr-3 drop-shadow-sm">
                  {packages.basic.icon}
                </span>
                <span className="font-bold text-xl">Card + Band Aid</span>
                <input
                  type="radio"
                  name="package"
                  value="basic"
                  checked={selectedPackage === "basic"}
                  onChange={() => setSelectedPackage("basic")}
                  className="ml-auto accent-[#2d348f] scale-125"
                />
              </div>
              <div className="text-sm text-gray-600 mb-4">
                {packages.basic.details}
              </div>
              <div className="flex gap-4 mt-auto">
                <label className="flex items-center text-sm font-medium">
                  <input
                    type="radio"
                    name="paymentType-basic"
                    value="oneTime"
                    checked={
                      selectedPackage === "basic" && paymentType === "oneTime"
                    }
                    onChange={() => {
                      setSelectedPackage("basic");
                      setPaymentType("oneTime");
                    }}
                    className="mr-1 accent-[#2d348f]"
                  />
                  $5.00 Monthly
                </label>
                <label className="flex items-center text-sm font-medium">
                  <input
                    type="radio"
                    name="paymentType-basic"
                    value="yearly"
                    checked={
                      selectedPackage === "basic" && paymentType === "yearly"
                    }
                    onChange={() => {
                      setSelectedPackage("basic");
                      setPaymentType("yearly");
                    }}
                    className="mr-1 accent-[#2d348f]"
                  />
                  $50.00/year
                </label>
              </div>
            </label>
            {/* Package 2 */}
            <label
              className={`flex-1 border-2 rounded-2xl p-6 flex flex-col cursor-pointer transition-all shadow-sm ${
                selectedPackage === "premium"
                  ? "border-[#2d348f] bg-[#f7f8fa] ring-2 ring-[#2d348f]/20"
                  : "border-gray-200 bg-white"
              } hover:shadow-lg group relative`}
            >
              <div className="flex items-center mb-3">
                <span className="text-4xl mr-3 drop-shadow-sm">
                  {packages.premium.icon}
                </span>
                <span className="font-bold text-xl">
                  Complete Medical Records
                </span>
                <input
                  type="radio"
                  name="package"
                  value="premium"
                  checked={selectedPackage === "premium"}
                  onChange={() => setSelectedPackage("premium")}
                  className="ml-auto accent-[#2d348f] scale-125"
                />
              </div>
              <div className="text-sm text-gray-600 mb-4">
                {packages.premium.details}
              </div>
              <div className="flex gap-4 mt-auto">
                <label className="flex items-center text-sm font-medium">
                  <input
                    type="radio"
                    name="paymentType-premium"
                    value="oneTime"
                    checked={
                      selectedPackage === "premium" && paymentType === "oneTime"
                    }
                    onChange={() => {
                      setSelectedPackage("premium");
                      setPaymentType("oneTime");
                    }}
                    className="mr-1 accent-[#2d348f]"
                  />
                  $10.00 Monthly
                </label>
                <label className="flex items-center text-sm font-medium">
                  <input
                    type="radio"
                    name="paymentType-premium"
                    value="yearly"
                    checked={
                      selectedPackage === "premium" && paymentType === "yearly"
                    }
                    onChange={() => {
                      setSelectedPackage("premium");
                      setPaymentType("yearly");
                    }}
                    className="mr-1 accent-[#2d348f]"
                  />
                  $100.00/year
                </label>
              </div>
            </label>
          </div>
          <div className="w-full border-t border-gray-100 pt-6">
            <button
              className="w-full bg-[#2d348f] text-white font-semibold py-3 rounded-xl shadow hover:bg-[#4962d8] transition-all mb-3 text-lg"
              onClick={() => onPay({ selectedPackage, paymentType, price })}
            >
              {payLabel}
            </button>
            <button
              className="w-full bg-gray-100 text-[#2d348f] font-medium py-3 rounded-xl hover:bg-gray-200 transition-all"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
